import React from 'react';

const Skills = () => {
  const skillCategories = [
    {
      title: "Languages",
      skills: ["JavaScript/TypeScript (Proficient)", "Python", "Java", "SQL/NoSQL"]
    },
    {
      title: "Frontend",
      skills: ["React.js", "Angular", "HTML/CSS"]
    },
    {
      title: "Backend",
      skills: ["Node.js", "Express", "NestJS", "REST APIs", "Microservices"]
    },
    {
      title: "Databases",
      skills: ["MongoDB", "MySQL", "Redis"]
    },
    {
      title: "DevOps",
      skills: ["Azure", "CI/CD Pipelines", "GitHub Actions", "Docker", "Kubernetes"]
    },
    {
      title: "Tools",
      skills: ["VS Code", "Kafka", "WebSockets", "Linux"]
    }
  ];

  return (
    <section id="skills" className="py-20 px-4 bg-gray-800">
      <div className="container mx-auto">
        <h2 className="text-3xl font-bold mb-12 text-center">
          <span className="border-b-4 border-blue-400 pb-2">Technical Skills</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {skillCategories.map((category, index) => (
            <div key={index} className="bg-gray-700 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-4 text-blue-400">{category.title}</h3>
              <ul className="space-y-2">
                {category.skills.map((skill, i) => (
                  <li key={i} className="text-gray-300 flex items-center">
                    <span className="w-2 h-2 bg-blue-400 rounded-full mr-2"></span>
                    {skill}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;